export default "__VITE_ASSET__DgMTTRHe__"